import { MenuTargets } from '@/models/Simulation/Constants'

export default {
  MenuSetting: {
    id: null,
    targetCode: [MenuTargets.VISITOR, MenuTargets.RESIDENT],
    enableBulkSetting: false,
    radius: 1000,
    visitCount: 1,
    minutesAgo: 259200,
    simulationCustomLocationGroups: [],
    simulationPoiLocationGroups: [],
  },
}
